import React, { useEffect, useState, useMemo, useCallback, Suspense, lazy } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import PoServices from "../../../services/PoServices";
import Swal from "sweetalert2";


import Select from 'react-select';
import { Spinner } from 'react-bootstrap';


import PoViewModal from './PoViewModal';
import QuatationModal from './QuatationModal';
import ManualQuotationModal from '../Quatation/ManualQuotationModal';
import Loader from "../Loader/loader";

const PendingPo = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [sort, setSort] = useState(40);
  const [showManualQuotationModal, setShowManualQuotationModal] = useState(false);
  const [manualQuotationRow, setManualQuotationRow] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [pendingPOs, setPendingPOs] = useState([]);
  const [activePage, setActivePage] = useState(0);
  const [test, setTest] = useState(0);
  const [selectedItem, setSelectedItem] = useState();
  const [loading, setLoading] = useState(true);
  const [showQuotationModal, setShowQuotationModal] = useState(false);
  const [selectedQuotationItem, setSelectedQuotationItem] = useState(null);
  const [showEditModal, setShowEditModal] =
    useState(false);

  const [selectedEditRow, setSelectedEditRow] =
    useState(null);

  const QtySendHOModal = lazy(() => import("./QtySendHOModal"));

  useEffect(() => {
    const fetchPendingPOs = async () => {
      try {
        setLoading(true); // Start loader
        const response = await PoServices.pendingPo();
        const poList = response?.data || [];
        setPendingPOs(poList);
      } catch (error) {
        Swal.fire("Error", "Failed to fetch pending POs", "error");
      } finally {
        setLoading(false); // End loader
      }
    };

    fetchPendingPOs();
  }, [test]);



  const filteredSearch = useMemo(() => {
    return pendingPOs.filter(po =>
      po?.store?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      po?.requisitionNo?.toString().includes(searchTerm)
    );
  }, [pendingPOs, searchTerm]);

  const paginatedData = useMemo(() => {
    return filteredSearch.slice(
      activePage * sort,
      (activePage + 1) * sort
    );
  }, [filteredSearch, sort, activePage]);


  const totalCount = filteredSearch.length;

  const options = [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
  ];

  useEffect(() => {
    if (pendingPOs.length > 0) {
      setActivePage(0);
    }
  }, [pendingPOs]);

  const pagination = Math.ceil(filteredSearch.length / sort);

  const onClick = (i) => {
    setActivePage(i);
  };

  const handleViewClick = useCallback(async (row) => {
    try {

      // 🔥 RESET FIRST
      setSelectedItem(null);

      const response = await PoServices.getPOItemsByRequestId(row._id);

      const items = response?.data || [];

      setSelectedItem({
        ...row,
        items: items
      });

      // ✅ OPEN AFTER DATA READY
      setGridInsideModal(true);

    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to load items", "error");
    }
  }, []);



  const handleGetQuotationClick = useCallback((row) => {
    setSelectedQuotationItem(row);
    setShowQuotationModal(true);
  }, []);


  // ✅ Download Excel function
  const handleDownloadExcel = useCallback(async () => {
    try {
      // ✅ LOADER WITH PROGRESS TEXT
      let timerInterval;
      Swal.fire({
        title: "Preparing Excel...",
        html: "Downloading... <b>0%</b>",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();

          let progress = 0;
          timerInterval = setInterval(() => {
            progress += 10;
            const b = Swal.getHtmlContainer().querySelector("b");
            if (b) b.textContent = `${progress}%`;

            if (progress >= 90) clearInterval(timerInterval); // stop at 90%
          }, 200);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      });

      // ✅ OPTIONAL PAYLOAD (if filters later)
      const payload = {};

      const response = await PoServices.downloadPOReport(payload);

      // ✅ COMPLETE PROGRESS
      const b = Swal.getHtmlContainer()?.querySelector("b");
      if (b) b.textContent = "100%";

      // ✅ CREATE BLOB
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // ✅ DYNAMIC FILE NAME (DATE BASED)
      const today = new Date();
      const formattedDate = today
        .toLocaleDateString("en-GB")
        .replace(/\//g, "-"); // 06-05-2026

      const fileName = `PendingPOs_${formattedDate}.xlsx`;

      // ✅ DOWNLOAD
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();

      Swal.close();

    } catch (error) {
      console.error("Download error:", error);

      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Unable to download Excel",
      });
    }
  }, []);

  const handleManualQuotationClick = (row) => {
    setManualQuotationRow(row);
    setShowManualQuotationModal(true);
  };

  const handleEditClick = (row) => {

    setSelectedEditRow(row);

    setShowEditModal(true);

  };


  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const TableRows = useMemo(() => {
    return paginatedData.map((row, index) => (
      <tr key={index}>
        <td>{activePage * sort + index + 1}</td>

        <td className="scrollable-description">{row?.store}</td>
        <td>{row?.requisitionNo}</td>

        <td>{formatDate(row?.createdAt)}</td>
        <td>{formatDate(row?.updatedAt)}</td>

        <td>{row?.itemCount}</td>

        <td className="text-center">

          <i
            className="fa fa-edit text-warning me-2"
            style={{
              cursor: "pointer",
              fontSize: "18px"
            }}
            title="Edit PO"
            onClick={() => handleEditClick(row)}
          ></i>

          <i
            className="fa fa-plus-circle text-success"
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={() => handleViewClick(row)}
          ></i>
        </td>

        <td className="text-center">
          <i
            className="fab fa-whatsapp text-success me-3"
            style={{ cursor: "pointer", fontSize: "20px" }}
            onClick={() => handleGetQuotationClick(row)}
          ></i>

          <i
            className="fa fa-edit text-warning"
            style={{ cursor: "pointer", fontSize: "16px" }}
            onClick={() => handleManualQuotationClick(row)}
          ></i>
        </td>
      </tr>
    ));
  }, [
    paginatedData,
    sort,
    activePage,
    handleViewClick,
    handleGetQuotationClick
  ]);

  useEffect(() => {
    setActivePage(0);
  }, [sort]);

  useEffect(() => {
    setActivePage(0);
  }, [searchTerm]);

  return (
    loading ? (
      <Loader />
    ) : (
      <>
        {/* ✅ Qty Send HO Modal */}
        {showEditModal && (
          <Suspense fallback={null}>
            <QtySendHOModal
              show={showEditModal}
              handleClose={() =>
                setShowEditModal(false)
              }
              row={selectedEditRow}
              refreshTable={() =>
                setTest(prev => prev + 1)
              }
            />
          </Suspense>
        )}
        {/* ✅ PO View Modal */}
        {gridInsideModal && (
          <PoViewModal
            items={selectedItem}
            show={gridInsideModal}
            test={setTest}
            handleClose={() => setGridInsideModal(false)}
          />
        )}

        {/* ✅ Quotation Modal */}
        {showQuotationModal && (
          <QuatationModal
            show={showQuotationModal}
            data={selectedQuotationItem}
            handleClose={() => setShowQuotationModal(false)}
          />
        )}

        {/* ✅ Manual Quotation Modal */}
        {showManualQuotationModal && (
          <ManualQuotationModal
            show={showManualQuotationModal}
            handleClose={() => setShowManualQuotationModal(false)}
            row={manualQuotationRow}
          />
        )}



        <div className="row">
          <div className="col-xl-12">
            {/* Filter box */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`} onClick={() => setOpen(!open)}>
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-xxl-6">
                        <input
                          type="text"
                          className="form-control mb-xl-0 mb-3"
                          placeholder="Search by store or requisition no"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <div className="col-xl-3 col-xxl-6">
                        <Select
                          placeholder="Rows per page"
                          value={options.find(option => option.value === sort)}
                          onChange={(selectedOption) => setSort(Number(selectedOption.value))}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select mb-3 mb-xxl-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Data Table */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title d-flex justify-content-between align-items-center">
                {/* Left side: Title */}
                <div className="cpa">
                  <i className="fa fa-list me-2" aria-hidden="true"></i>
                  Pending PO <span className="badge bg-orange ms-2">{totalCount}</span>
                </div>

                {/* Right side: Download + Collapse Tools */}
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={handleDownloadExcel}
                  >
                    <i className="fa fa-download me-1"></i>Download Excel
                  </button>

                  <div className="tools">
                    <Link
                      to="#"
                      className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                      onClick={() => setOpen2(!open2)}
                    >
                      <i className="fas fa-angle-up"></i>
                    </Link>
                  </div>
                </div>
              </div>

              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div id="content_wrapper" className="dataTables_wrapper no-footer">
                        <div style={{
                          overflowX: 'auto',
                          overflowY: 'auto',
                          maxHeight: '400px',
                          whiteSpace: 'nowrap'
                        }}>
                          <table className="table table-bordered table-responsive-lg table-striped table-condensed flip-content" id="active-users-data">
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                backgroundColor: "#fff", // White background
                                zIndex: 2,
                              }}
                            >
                              <tr>
                                <th>S.No</th>
                                <th>Store</th>
                                <th>Requisition</th>
                                <th>Created Date</th>
                                <th>Approved Date</th>
                                <th>Item Count</th>
                                <th>Actions</th>
                                <th>Get Quotation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {totalCount > 0 ? (
                                TableRows
                              ) : (
                                <tr>
                                  <td colSpan="8" className="text-center">
                                    No Pending PO Records Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {totalCount > 0 ? (activePage * sort + 1) : 0} to{" "}
                            {Math.min(totalCount, (activePage + 1) * sort)}{" "}
                            of {totalCount} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers">
                            <Link
                              className="paginate_button previous"
                              to="#"
                              onClick={() =>
                                activePage > 0 &&
                                onClick(activePage - 1)
                              }
                            >
                              <i
                                className="fa fa-angle-double-left"
                                aria-hidden="true"
                              ></i>
                            </Link>
                            <span>
                              {Array.from({ length: pagination }, (_, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button ${activePage === i ? "current" : ""
                                    }`}
                                  onClick={() => onClick(i)}
                                >
                                  {i + 1}
                                </Link>
                              ))}
                            </span>
                            <Link
                              className="paginate_button next"
                              to="#"
                              onClick={() =>
                                activePage < pagination - 1 &&
                                onClick(activePage + 1)
                              }
                            >
                              <i
                                className="fa fa-angle-double-right"
                                aria-hidden="true"
                              ></i>
                            </Link>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </>
    )
  )
};

export default PendingPo;
